import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { OfflineProvider } from './contexts/OfflineContext';
import { useCapacitor } from './hooks/useCapacitor';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import Lists from './pages/Lists';
import ListDetail from './pages/ListDetail';
import InviteAccept from './pages/InviteAccept';
import Settings from './pages/Settings';
import Privacy from './pages/Privacy';
import Imprint from './pages/Imprint';
import Changelog from './pages/Changelog';
import { AdminDashboard } from './pages/AdminDashboard';
import SupermarketList from './pages/SupermarketList';
import SupermarketCreate from './pages/SupermarketCreate';
import PrivateRoute from './components/PrivateRoute';
import { FeatureAnnouncement } from './components/FeatureAnnouncement';

function AppContent() {
  // Capacitor Hooks für native Features
  useCapacitor();

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
      
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/invite/:token" element={<InviteAccept />} />
      <Route path="/datenschutz" element={<Privacy />} />
      <Route path="/impressum" element={<Imprint />} />
      <Route path="/changelog" element={<Changelog />} />
      
      <Route path="/lists" element={<PrivateRoute><Lists /></PrivateRoute>} />
      <Route path="/lists/:listId" element={<PrivateRoute><ListDetail /></PrivateRoute>} />
      <Route path="/supermarkets" element={<PrivateRoute><SupermarketList /></PrivateRoute>} />
      <Route path="/supermarkets/create" element={<PrivateRoute><SupermarketCreate /></PrivateRoute>} />
      <Route path="/supermarkets/:id/edit" element={<PrivateRoute><SupermarketCreate /></PrivateRoute>} />
      <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
      <Route path="/admin" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    <FeatureAnnouncement />
    </>
  );
}

function App() {
  return (
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
    <BrowserRouter>
      <ThemeProvider>
        <OfflineProvider>
          <AuthProvider>
            <SocketProvider>
              <AppContent />
            </SocketProvider>
          </AuthProvider>
        </OfflineProvider>
      </ThemeProvider>
    </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;
